export default "__VITE_ASSET__CySiggfE__"